import React, {Component} from 'react';
import axios from 'axios'
import DialogBox from './dialogBox';
import Errorbar from '../common/errorbar';
import NoDataBar from '../common/noDataBar';
import i18n from '../../i18n'

//PC版カレンダー関係
import {DatePicker} from 'antd';
import moment from 'moment';
import 'antd/dist/antd.css';
import './flows.css';

//ページネーション feature#1
import ReactPaginate from 'react-paginate';
import { ArrowBackIosRounded, ArrowForwardIosRounded } from '@material-ui/icons';

class Flows extends Component {
    
    constructor(props){
        super(props)
        this.state = {
            imgList:[],
            img:[
                {
                "timestamp": "",
                "materialFlow": 0,
                "latitude": 0,
                "longitude": 0,
                "address": "",
                "encodevalue": [],
                "worker": ""
                }
            ],  
            openDialog:false,
            openErrorBar:false,
            openNoDataBar:false,
            noDataErr:false,
            nowMonth:"",
            selectedMonth:"",
            selectedFlow:0,
            buttonIndex:0, //ダイアログボックスのボタン用
            errorMessage:"",
            //レスポンシブデザイン 
            bodyMinHeight:0,
            imgWidth:0,
            imgHeight:0,
            marginLeft:0,
            today: moment(),
            //ページネーション feature#1
            viewImgNum: 6,      //　一度に表示する画像の最大値
            imgMaxNum: 0,       //  全データ数
            pageNo: 1,          //  表示しているページ番号
            pageMax: 1,         //  全ページ数
        }
    }
   /** feature#1 ページネーション対応のデータ取得 */
   getdatePg=()=>{
        // APIパス設定
        var apiPath = process.env.REACT_APP_ENDPOINT + 'viewTraceDataPg/'
        // １ページで表示する画像数
        var imgnum = this.state.viewImgNum;
        console.log("apiPath::"+process.env.REACT_APP_ENDPOINT);
        console.log("imgnum ::"+imgnum);
        console.log("pageNo ::"+this.state.pageNo);
        /** APIに渡すパラメータ 作成*/
        var params = new URLSearchParams();
        params.append( "materialid", this.state.selectedFlow);
        params.append( "viewyyyymm", '\'' + this.state.selectedMonth.replace("-", "") + '\'');
        params.append( "imageNum"  , imgnum);
        params.append( "pageNo"    , this.state.pageNo);
        //params.append( "pageNo"    , 1);
        var request = {
            params: params
        };
        axios.get(apiPath, request
/*            {
                Params:{
                    materialid:this.state.selectedFlow,
                    viewyyyymm:'\'' + this.state.selectedMonth.replace("-", "") + '\'',
                    imageNum:this.state.viewImgNum,
                    pageNo:this.state.pageNo
                }
            } */
        ).then((response)=>{
            /** feature#1 :: ページネーションの為、
             **               総イメージ数　や　ページ数の処理を追加   */
            
            // データ配列の先頭には、総イメージ数をセット {totalImage}
            // var res1 = JSON.stringify(response.data[0]); //確認用
            var totalimgNum = response.data[0].totalImage;

            //console.log("総データ数⇒"+totalimgNum+"..１ページに表示する数⇒"+this.state.viewImgNum)
            //console.log("除算(/)::"+totalimgNum/this.state.viewImgNum+"...剰余(%)::"+totalimgNum%this.state.viewImgNum);

            //  総ページ数　データ数／データ表示数の結果を Math の切上げ関数 ceil に渡す
            var pagenum = Math.ceil(totalimgNum/this.state.viewImgNum)

            //console.log("ページ数::"+pagenum)
            /** feature#1 */
            // データを保存
            this.setState({ imgList   : response.data.slice(1), /** 先頭には総データ数が入っているはず feature#1 */
                            imgMaxNum : totalimgNum,            /** 全データ数 feature#1 */
                            pageMax   : pagenum,                /** ページ数 feature#1 */
                            noDataErr : false,
                        })
            this.removeDisabled()
        }).catch((error)=>{
            console.log(error)
            if(typeof error.response != "undefined" && error.response.status === 500){
                this.handleNoDataBarOpen()
                this.setState({ noDataErr:true,
                                errorMessage:i18n.t('flows.no_data')})
            } else if(typeof error.response != "undefined" && error.response.status === 501){
                this.handleErrorbarOpen()
                this.setState({errorMessage:i18n.t('flows.can_not_get_data')})
            }else{
                this.handleErrorbarOpen()
                this.setState({errorMessage:i18n.t('flows.server_error')})
            }
            this.removeDisabled()
        })
   }

    //apiでデータを取得
    getdata=()=>{
        var api= process.env.REACT_APP_ENDPOINT + 'viewTraceData/'
        axios.get(api,
            {
                params:{
                    materialid:this.state.selectedFlow,
                    viewyyyymm:'\'' + this.state.selectedMonth.replace("-", "") + '\''
                }
            }
        )
        .then((response)=>{
            this.setState({
                imgList:response.data.slice(1),
                noDataErr:false
            })
            this.removeDisabled()
        })
        .catch((error)=>{
            console.log(error)
            if(typeof error.response != "undefined" && error.response.status === 500){
                this.handleNoDataBarOpen()
                this.setState({noDataErr:true})
                this.setState({errorMessage:i18n.t('flows.no_data')})
            } else if(typeof error.response != "undefined" && error.response.status === 501){
                this.handleErrorbarOpen()
                this.setState({errorMessage:i18n.t('flows.can_not_get_data')})
            }else{
                this.handleErrorbarOpen()
                this.setState({errorMessage:i18n.t('flows.server_error')})
            }
            this.removeDisabled()
        })
    }

    //selectboxのdisabled属性を削除する
    removeDisabled(){
        var selectFlows = document.getElementById("selectFlows")
        /** feature#1 *
        var selectMonth = document.getElementById("selectMonth")
        */
        selectFlows.removeAttribute("disabled")
        /** feature#1 *
        selectMonth.removeAttribute("disabled")
        */
    }

    //selectboxにdisabled属性を追加する
    addDisabled(){
        var selectFlows = document.getElementById("selectFlows")
        /** feature#1 *
        var selectMonth = document.getElementById("selectMonth")
        */
        selectFlows.setAttribute("disabled", "disabled")
        /** feature#1 *
        selectMonth.setAttribute("disabled", "disabled")
        */
    }

    //selectのonchangeイベント
    onChangeSelectbox=(e)=>{
        console.log("onChangeSelectbox::");
        var value = e.target.value
        this.setState({
                selectedFlow:value,
                pageNo:1
                }, ()=>{
            //this.getdata()
            this.getdatePg()
        })
        this.addDisabled()
    }

    onChangeSelectMonth=()=>{
        var selectedMonth = document.getElementById("selectMonth").value
        selectedMonth = selectedMonth.replace("年", "-")
        selectedMonth =　selectedMonth.replace("月", "")
        this.setState({
                selectedMonth:selectedMonth,
                pageNo:1
                }, ()=>{
                //this.getdata()
                this.getdatePg()
        })
        this.addDisabled()
    }

    onBlurSelectMonth=()=>{
        var selectedMonth = document.getElementById("selectMonth").value
        if(selectedMonth != this.state.selectedMonth){
            this.onChangeSelectMonth()
        }
    }
    
    showDialog=(e)=>{
        var id = e.target.id
        var img = []
        img.push(this.state.imgList[id])
        this.setState({
            buttonIndex:0,
            img:img,
            openDialog:true
        })
    }

    closeDialog=()=>{
        this.setState({openDialog:false})
    }

    //ボタンで同じ日付の画像をスウィッチ、<DialogBox/>に渡す
    changeIndex=(id)=>{
        this.setState({buttonIndex:id})
    }

    //エラー版バー
    handleErrorbarOpen=()=>{
        this.setState({openErrorBar:true})
    }

    handleErrorbarClose=()=>{
        this.setState({openErrorBar:false})
    }

    handleNoDataBarOpen=()=>{
        this.setState({openNoDataBar:true})
    }

    handleNoDataBarClose=()=>{
        this.setState({openNoDataBar:false})
    }

    componentWillMount=()=>{

        //現在の年月を取得
        var today = new Date()
        var nowYear = today.getFullYear()
        var nowMonth = today.getMonth() + 1
        var now = ""
        if(nowMonth < 10){
            now = nowYear + "-0" + nowMonth 
        }else{
            now = nowYear + "-" + nowMonth
        }
        this.setState({selectedMonth:now, nowMonth:now})
        //process.jsからのpropsを取得
        if(typeof this.props.location.state != "undefined"){
            this.setState({selectedFlow:this.props.location.state.selectedFlow}, ()=>{
                this.getdatePg() // feature#1 ページネーション対応
            })
        }else{
            this.setState({selectedFlow:8}, ()=>{
                this.getdatePg() // feature#1 ページネーション対応
            })
        }

        //レスポンシブデザイン
        this.handleResize()
        window.addEventListener('resize', this.handleResize)

        //topまでスクロール
        window.scrollTo(0,0)
    }

    //レスポンシブデザイン
    handleResize=()=>{
        var windowWidth = window.innerWidth
        var windowHeight = window.innerHeight
        var footerHeight = 120
        if(windowWidth <= 1024){
            var HeaderHeight = 130
            var imgWidth = 0.3125 * windowWidth
            var imgHeight = imgWidth
            var marginLeft = "12.5%"
        }else{
            var HeaderHeight = 180
            var imgWidth = 0.2267 * windowWidth
            var imgHeight = imgWidth
            var marginLeft = "8%"
        }
        var bodyMinHeight = windowHeight - HeaderHeight - footerHeight
        this.setState({
            bodyMinHeight: bodyMinHeight,
            imgWidth: imgWidth,
            imgHeight: imgHeight,
            marginLeft: marginLeft
        })
    }

    //カレンダーに選べれる範囲を設定
    disabledDate(current) {
       return current < moment('2020/08').endOf('day') || current > moment().endOf('day');
    }

    /** feature#1 ::ページ送りクリック時の処理
    ** 　　　　　　　パラメータに選択されたページのインデックス
    **              {selected} */
    handlePaginate=(Params)=>{
        //var logm = JSON.stringify(Params);
        var selpageIndex = Params.selected;
//        console.log("handlePagenate() Selected Page Index::"+selpageIndex);
        //
        this.setState({pageNo:selpageIndex+1}, ()=>{
            this.getdatePg()     // feature#1 ページネーション対応
        })
        this.addDisabled()
    };

    render(){

        //登録画像サマリ表示
        var imgArr = []
        if(this.state.noDataErr == false){
            imgArr = this.state.imgList.map((item,index)=>{
                if(typeof item.encodevalue === "string"){
                    return(
                        <div key={index} style={{width:this.state.imgWidth, textAlign:"center", marginTop:"20px", marginLeft:this.state.marginLeft, display:"inline-block"}}>
                            <img id={index} src={item.encodevalue} style={{width:this.state.imgWidth, height:this.state.imgHeight}} onClick={this.showDialog}></img><br/>
                            <p style={{fontSize:"30px", marginTop:"5px"}}>{item.timestamp}</p>
                        </div>
                    )
                }
                else if(typeof item.encodevalue === "object"){
                    return(
                        <div key={index} style={{width:this.state.imgWidth, textAlign:"center", marginTop:"20px", marginLeft:this.state.marginLeft, display:"inline-block"}}>
                            <img id={index} src={item.encodevalue[0]} style={{width:this.state.imgWidth, height:this.state.imgHeight}} onClick={this.showDialog}></img><br/>
                            <p style={{fontSize:"30px", marginTop:"5px"}}>{item.timestamp}</p>
                        </div>
                    )
                }
            })
        }else{
            imgArr = []
        }
        /** feature#1 */
        const LAST_DISPLAY_SIZE = 7;
        const AROUND_DISPLAY_PAGES = 4;
        
        return(
            <div style={{minHeight:this.state.bodyMinHeight}}>
                <Errorbar open={this.state.openErrorBar} handleClose={this.handleErrorbarClose} message={this.state.errorMessage} />
                <NoDataBar open={this.state.openNoDataBar} handleClose={this.handleNoDataBarClose} message={this.state.errorMessage} />
                <select className={"selectFlows"} id={"selectFlows"} defaultValue={this.state.selectedFlow} style={styles.selectFlows} onChange={this.onChangeSelectbox} disabled>
                    <option style={styles.option} value={8}>{i18n.t('flows.get_straw')}</option>
                    <option style={styles.option} value={1}>{i18n.t('flows.spread_straw')}</option>
                    <option style={styles.option} value={2}>{i18n.t('flows.straw_recovery')}</option>
                    <option style={styles.option} value={3}>{i18n.t('flows.straw_convey')}</option>
                    <option style={styles.option} value={4}>{i18n.t('flows.mushroom_bed')}</option>
                    <option style={styles.option} value={5}>{i18n.t('flows.begin_cultivation')}</option>
                    <option style={styles.option} value={6}>{i18n.t('flows.cultivation')}</option>
                    <option style={styles.option} value={7}>{i18n.t('flows.harvest')}</option>
                </select><br/>
                {/** feature#1
                <div className="selectMonthArea" style={styles.selectMonthArea}>
                    <h1 style={styles.h1}>{i18n.t('flows.period')}</h1>
                    {selectMonthForm}
                </div>
                ** */}
                <div className="imgArea" style={styles.imgArea}>
                    {imgArr}
                    <DialogBox
                        open={this.state.openDialog}
                        data={this.state.img}
                        buttonIndex = {this.state.buttonIndex}
                        closeDialog={this.closeDialog}
                        changeIndex={this.changeIndex}
                    />
                </div>
                {/** feature#1 ページ送りの表示設定*/}
                {/** console.log("PagiNate::"+this.state.pageMax) */}
                <div className="pagination justify-content-center" style={this.state.pageMax>1? styles.pagiNate:styles.pagiNate_non}>
                    <ReactPaginate
                        setCurrentPageNumber={this.state.pageNo-1}      /** 現在のページ位置をセット */
                        pageCount={this.state.pageMax}                  /** 総ページ数 */
                        marginPagesDisplayed={LAST_DISPLAY_SIZE}        /** 終端に表示する件数 */
                        pageRangeDisplayed={AROUND_DISPLAY_PAGES}       /** 選択位置の前後で表示する件数 */
                        onPageChange={this.handlePaginate}              /** ページクリック時にハンドルするメソッド */
                        containerClassName="pagination"                 /** pageのulタグに設定するclass */
                        pageClassName="page-item"                       /** pageのliタグに設定するclass */
                        pageLinkClassName="page-link"                   /** pageのaタグに設定するclass */
                        activeClassName="active"                        /** 現在activeなpageに設定するclass */
                        activeLinkClassName="active"                    /**  */
                        previousLinkClassName="page-item"           /** previousのliタグに設定するclass */
                        nextLinkClassName="page-item"                    /** nextのliタグに */
                        previousLabel={arrowIconL()}                    /** previousに設定するラベル名 */
                        nextLabel={arrowIconR()}                        /** nextに設定するラベル名 */
                        disabledClassName="disabled"             /** previous/nextが押せなくなった状態の表示 */
                    />
                </div>
                <p style={{height:"50px"}}/>
            </div>
        )
    }
}
/** feature#1 ページネーションの　previous 用 */
const arrowIconL = () => {
    return (
      <ArrowBackIosRounded/>
    );
};
/** feature#1 ページネーションの　next 用 */
const arrowIconR = () => {
    return (
      <ArrowForwardIosRounded/>
    );
};

const styles = {
    returnButton:{
        height:"75px",
        width:"130px",
        position:"relative",
        left:"15%",
        marginTop:"20px",
        fontSize:"30px",
        color:"white"
    },
    selectFlows:{
        appearance:"none",
        MozAppearance: "none",
        WebkitAppearance:"none",
        padding:"15px 0",
        width:"70%",
        left:"15%",
        borderRadius:"4px",
        position:"relative",
        background:"#E9E1D1",
        appearance:"none",
        marginTop:"10px",
        fontSize:"30px",
        textAlignLast:"center",
        outline:"none",
        cursor: "pointer"
    },
    option:{
        background: "#F9F9F9"
    },
    selectMonth:{
        fontSize:"30px",
        marginTop:"-10px",
        width:"260px",
        cursor: "pointer",
    },
    imgArea:{
        position:"relative",
        minHeight:"80px",
    },
    h1:{
        fontSize:"30px", 
        marginRight:"30px", 
        display:"inline",
    },
    selectMonthArea:{
        display:"flex", 
        justifyContent:"center",
        marginTop:"30px",
        marginBottom:"10px"
    },
    pagiNate:{
        position:"relative",
        marginTop:"20px",
        width    : "100%"
    },
    pagiNate_non:{
        display: "none"
    }
}

export default Flows;